/**
 * @description
 * Window event dispatched by the App error boundary when rendering crashed,
 * lets features observe crashes without App depending on them
 */
export const APP_ERROR_EVENT = 'app:render-error';
